import { render, staticRenderFns } from "./editCubeMsg.vue?vue&type=template&id=1d7c9558&scoped=true&"
import script from "./editCubeMsg.vue?vue&type=script&lang=js&"
export * from "./editCubeMsg.vue?vue&type=script&lang=js&"
import style0 from "./editCubeMsg.vue?vue&type=style&index=0&id=1d7c9558&prod&lang=scss&"
import style1 from "./editCubeMsg.vue?vue&type=style&index=1&id=1d7c9558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c9558",
  null
  
)

export default component.exports